import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";

import { Link } from "react-router-dom";

import brandLogo from "../img/brand-logo.svg";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../features/auth/authSlice";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {},
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: "white",
    minHeight: '74px'
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: "var(--greyblue)",
  },
  hide: {
    display: "none",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },

}));

export default function ButtonAppBar({ handleShow }) {
  const user = useSelector(selectCurrentUser);
  const classes = useStyles();
  const [open] = React.useState(false);

  const BrandLogo = () => {
    return (
      <a href="/">
        <img src={brandLogo} alt="EncoreHive Logo" height="45px" />
      </a>
    )
  }

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar className="">

        <Grid
          alignItems="center"
          justifyContent="space-between" // Add it here :)
          container
          spacing={0} //was 10 changed to 0
          wrap='nowrap'
        >
          <Grid item >
            <BrandLogo />
          </Grid>

          <Grid item
            alignItems="center"
            justifyContent="flex-end"
            container
            spacing={0}
            wrap='nowrap'
          >
            <Link to="/signup" className={classes.link} style={{ textDecoration: 'none' }}>
              <Button
                variant="contained"
                sx={{ margin: '0 0 0 1em' }}
              >
                Sign Up
              </Button>
            </Link>
            {(user && user.id) ? (
              <Link to="/dashboard/jobs" className={classes.link}>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ margin: '0 0 0 1em' }}
                  onClick={handleShow}
                >
                  Dashboard
                </Button>
              </Link>
            ) : (
              <Button
                variant="contained"
                color="secondary"
                sx={{ margin: '0 0 0 1em' }}
                onClick={handleShow}
              >
                Sign In
              </Button>
            )}
          </Grid>

        </Grid>
      </Toolbar>
    </AppBar >
  );
}
